module.exports = __webpack_public_path__ + "img/verification-process-2-en.23938634.png";